import type { BloomPainting } from "../present/bloomPainting";
import { BLOOM_HOME } from "../present/bloomTurnState";

export const storyMotionState = {
  progress: 0,
  pointerX: 0,
  pointerY: 0,
  energy: 0,
  bloom: 0,
  charge: 0,
  palette: 0,
  flowerTurn: { ...BLOOM_HOME },
  collected: 0,
  flowerPaint: null as BloomPainting | null,
};

export function resetStoryMotionState() {
  storyMotionState.progress = 0;
  storyMotionState.pointerX = 0;
  storyMotionState.pointerY = 0;
  storyMotionState.energy = 0;
  storyMotionState.bloom = 0;
  storyMotionState.charge = 0;
  storyMotionState.palette = 0;
  storyMotionState.flowerTurn = { ...BLOOM_HOME };
  storyMotionState.collected = 0;
  storyMotionState.flowerPaint = null;
}

export function setStoryMotion(values: Partial<typeof storyMotionState>) {
  Object.assign(storyMotionState, values);
  window.dispatchEvent(new Event("birthday-scene-change"));
}
